<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintClassification border_bottom">
          <div class="left">投诉时间</div>
          <div class="right">
            <span>{{itemList.complain_time}}</span>
          </div>
        </div>
      </div>
      <div class="urgent">
        <div class="specificSituation border_bottom">
          <div class="left">赔偿金额</div>
          <div class="right">
            <input type="number" placeholder="请输入赔偿金额" v-model="money">
            <span style="position:relative;z-index:100">元</span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">履行地点</div>
          <div class="right">
            <input type="text" placeholder="请输入履行地点" v-model="address">
          </div>
        </div>
         <div class="uploadBox">
               <upload :imgUrl="imgUrl"></upload>
            </div>
        <div class="returnReas">
            <div class="text">事实经过</div>
            <div class="textar">
                    <textarea  maxlength="200" placeholder="请填写事实经过" class="txtarea"  v-model="facts"></textarea>
                    <span class="total">{{facts.length}}/200</span>
            </div>
        </div>
        <div class="returnReas">
            <div class="text">达成协议</div>
            <div class="textar">
                    <textarea  maxlength="200" placeholder="请填写达成协议" class="txtarea"  v-model="agreement"></textarea>
                    <span class="total">{{agreement.length}}/200</span>
            </div>
        </div>
        <div class="btn" @click="handleSubmit">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
    import util from '@/utils/common'
    import api from '@/service/modules/complaint';
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                money: '',
                address: '',
                facts: '',
                agreement: '',
                itemList: util.getJsonLocal('item'),
                imgUrl: [], // 上传的图片,
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
            }
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            // 提交
            handleSubmit () {
                let userInfo = this.$store.state.complaint.userInfo
                
                if (this.address.trim().length === 0) {
                    this.$Toast('请输入履行地点');
                } else if (this.facts.trim().length === 0||this.facts.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写事实经过');
                } else if (this.agreement.trim().length === 0||this.agreement.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请填写达成协议');
                } else {
                    var resultReson=this.facts.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    var resultReson1=this.agreement.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    // console.log(resultContent.replace(/\s*/g,""))
                    if(resultReson.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的事实经过');
                        return;
                    }else if(resultReson1.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的协议内容');
                        return;
                    }else{
                      const data = {
                          main_complain_number: this.itemList.main_complain_number,
                          complain_12301_number: this.itemList.complain_12301_number,
                          id: this.itemList.id,
                          sub_id: this.itemList.sub_id,
                          complain_number: this.itemList.complain_number,
                          type: 'conciliationSuccess',
                          money: this.money,
                          fact: this.facts.replace(/\s*/g,""),
                          agreement: this.agreement.replace(/\s*/g,""),
                          address: this.address,
                          result_type: 3,
                          imgUrl: this.imgUrl
                      }
                      api.disposeOperation(data).then((res) => {
                          console.log(res)
                          if (res.ret === 0) {
                              this.$Toast('操作成功');
                              // this.$router.go(-2);
                              if(!this.isback){
                                this.$router.go(-2);
                              }else{
                                  this.$router.back();
                                  this.$set(this.itemList,'btns',[]);
                                  util.setJsonLocal('item',this.itemList);
                              }
                              
                          }
                      })
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.box {
  width: 100%;
//   padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .uploadBox{
      margin-top: 20px;
    }
    .complaintInformation {
      width: 100%;
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation
     {
        display: flex;
        // height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation {
        .right {
          color: #ddd;
        }
      }
      .complaintTarget_class {
        color: #000000;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .urgent {
      width: 100%;
      font-size: 14px;
      .limitedProcesseTime {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          width: 60%;
          margin-left: 15px;
          display: flex;
          .van-field {
            border-bottom: 1px solid #ccc;
            height: 30px;
            margin-top: 10px;
            padding: 0;
          }
          span {
            color: #aaa;
          }
        }
      }
        .van-uploader {
                margin-top: 20px;
            }
      .upload{
            min-height: 44px;
            line-height: 50px;

            .upattach{
                font-size: 14px;
                color: #444444;
            }
            span{
                font-size: 12px;
                color: #BFBFBF;
            }
        }
        .btn {
            width: 100%;
            height: 46px;
            background-color: #36B374;
            line-height: 46px;
            color: #fff;
            text-align: center;
            font-size: 14px;
            border-radius: 5px;
        }
        .returnReas{
            font-size: 14px;
            margin-top:15px;
            .text{
                height: 20px;
                // color: #9C9C9C;
                color: #BFBFBF;
                // margin-left: 0.426667rem;
                padding-bottom:15px;
            }
            .textar{
                margin-top: 5px;
                height: 110px;
                width: 100%;
                text-align: center;
                position: relative;
                .txtarea{
                    border: none;
                    border-radius: 5px;
                    padding-top: 10px;
                    padding-left: 10px;
                    background-color:#F2F2F2;
                    height: 100px;
                    width: 340px;
                    resize: none;
                }
                .total{
                  position: absolute;
                  right:6px;
                  bottom:6px;
                }
            }
        }
      .emergencyLabel,
      .complaintClass {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 30%;
          color: #aaa;
        }
        .right {
          display: flex;
          width: 50%;
          justify-content: space-between;
          div {
            width: 50px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            background-color: #fff;
            color: #aaa;
          }
          .tabColor {
            background-color: #3C8DE5;
            color: #fff;
          }
          .tabColor1 {
            background-color: #E6611E;
            color: #fff;
          }
          .tabColor2 {
            background-color: red;
            color: #fff;
          }
        }
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
    .specificSituation {
        display: flex;
        // height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          input {
              text-align: right;
              padding-right: 5px;
          }
        }
      }
  }
}
</style>
